import { gql } from '@apollo/client';

export interface DismissHubspotDealRequest {
  id: string;
}

export interface DismissHubspotDealResponse {
  dismissHubspotDeal: {
    id: string;
  };
}

export const DISMISS_HUBSPOT_DEAL = gql`
  mutation dismissHubspotDeal($id: String!) {
    dismissHubspotDeal(id: $id) {
      id
    }
  }
`;
